import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import logo from 'assets/images/logo/Logo-QL-White-Cyan.svg';
import exit from 'assets/images/logout.svg';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #35447d;
  height: 9rem;
  padding: 0 7rem;

  @media (max-width: 768px) {
    padding: 0 4rem;
  }

  .left-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: auto;
    width: 100%;

    .logo { height: 3.8rem; }
    .link-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 2rem;

      .white-link {
        font-size: 1.4rem;
        text-decoration: underline;
        color: white;
        margin: 0;
      }
      .exit-icon {
        margin-left: 1rem;
        height: 2.6rem;
        width: 2.6rem;
      }
    }
  }
  .right-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    .step {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.2rem;
      margin: 0 1rem;
      padding: 0 2rem 0.2rem 2rem;
    }
    .next {
      border-bottom: 2px solid #7b85b1;
      color: #7b85b1;
    }
    .current {
      border-bottom: 2px solid cyan;
      color: cyan;
    }
    .previous {
      border-bottom: 2px solid white;
      color: white;
    }
  }
`;

function getSteps(routes, session) {
  const steps = [];
  const currentRoute = window.location.pathname;
  let currentStepFound = false;
  let className = '';
  for (let i = 0; i < routes.length; i += 1) {
    if (routes[i].url === currentRoute) {
      currentStepFound = true;
      className = 'step current';
    } else if (currentStepFound) {
      className = 'step next';
    } else {
      className = 'step previous';
    }
    // Guard routes after step 1
    if (i === 0 || (i > 0 && session[`step${i}`].completed)) {
      steps.push(<Link to={routes[i].url} key={i + 1} className={className}>{i + 1}</Link>);
    } else {
      steps.push(<div key={i + 1} className={className}>{i + 1}</div>);
    }
  }
  return steps;
}

const ProgressNav = props => (
  <Wrapper>
    <div className="left-wrapper">
      <img className="logo" alt="QuickLegal logo" src={logo} />
      <Link to="/" className="link-wrapper">
        <p className="white-link">Back to site</p>
        <img className="exit-icon" alt="Back to site icon" src={exit} />
      </Link>
    </div>
    <div className="right-wrapper">
      {getSteps(props.routes, props.session)}
    </div>
  </Wrapper>
);

ProgressNav.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  session: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default ProgressNav;



// WEBPACK FOOTER //
// ./src/components/ProgressNav/index.js